module.exports = __webpack_public_path__ + "img/t4-i3.36f6d3d9.svg";